/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Not_Specified17Inputs */

const en__field_enum_icsrm_not_specified17 = /** @type {(inputs: _Field_Enum_Icsrm_Not_Specified17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not specfied`)
};

const de__field_enum_icsrm_not_specified17 = /** @type {(inputs: _Field_Enum_Icsrm_Not_Specified17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ohne Angabe`)
};

/**
* | output |
* | --- |
* | "not specfied" |
*
* @param {_Field_Enum_Icsrm_Not_Specified17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_not_specified17 = /** @type {((inputs?: _Field_Enum_Icsrm_Not_Specified17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Not_Specified17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_not_specified17(inputs)
	return de__field_enum_icsrm_not_specified17(inputs)
});
export { _field_enum_icsrm_not_specified17 as "_field_enum_ICSRM_NOT_SPECIFIED" }